// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"0c148785","400":"146f6f6f","428":"6c2b77f1","453":"0f4abbdb","782":"4ea26dbf"}[chunkId] + ".chunk.js";
};